import { DEFAULT_SPEECH_LANG } from '@configs';
import { getWordAt, getWordStart, LogApp } from '@utils';
import React, { useState } from 'react';
import styled from 'styled-components';

import useSpeechSynthesis from './useSpeechSynthesis';

export const SpeechSynthesisModule = () => {
  // const [text, setText] = useState(
  //   'In addition to the properties listed below, properties from the parent interface, Event, are available. charIndex Read only Returns the index position of the character in the SpeechSynthesisUtterance.text that was being spoken when the event was triggered. elapsedTime Read only Returns the elapsed time in seconds after the SpeechSynthesisUtterance.text started being spoken that the event was triggered at. name Read only Returns the name associated with certain types of events occurring as the SpeechSynthesisUtterance.text is being spoken: the name of the SSML marker reached in the case of a mark event, or the type of boundary reached in the case of a boundary event.',
  // );
  const text =
    'i　近年の急速な情報技術の発達により、経済のグローバル化が猛スピードで進行する一方、インターネットの普及により、地球上の他の国々や地域に住む未知の人々と繋がり合い、影響し合うことが瞬時にできるようになりました。　また、世界各地で頻発するテロ事件、大規模なストや暴動、それに大量の移民や難民の国外流出などの問題が起こると、その映像や情報はインターネットで瞬時に手元に届くので、私たちはそれらの問題がもはや遠い国での出来事ではなく、地球上に共に生きている友人や隣人のことのように捉えることができるようになってきています。したがって、私たちはグローバルな広い視野を身につけていないと、世界の出来事を正しく理解できないばかりか、この時代を自分がどう生きていけばよいか、不安になると思います。使える英語の必要性　こうしたグローバル化時代において、世界共通語としての英語の重要性は、ますます大きくなっているとの印象を強く受けます。非英語圏においても現地の母語と共に、英語がプライベートな会話や、オフィシャルな取引や交渉の際の共通のコミュニケーション手段として用いられる頻度は年々高くなっています。　外国語、特に英語学習への関心は、通訳・翻訳ボランティアとして活躍している若者たちやそこに従事する人々の間で強いように見受けられます。そして、「すぐに役に立つ英語」や「ホスピタリティー・イングリッシュ（おもてなし英語Hospitality English）」、それに災害時に役立つ「非常時緊急支援英語」など、草の根（grass root）レベルの英語の必要性が、最近声高に叫はじめに―Why English Now?　　　　　（今なぜ英語を学ぶのか）iiばれています。なぜなら、2018年に関西地方を襲った台風と地震の際には、空港で立ち往生し、困り果てている外国人観光客に対して、観光立国であったはずのわが国は、官民ともに十分に対応ができなかったのです。観光立国であったはずのわが国は、通訳やホスピタリティの面でほとんど手が打てなかったのです。もしそのような状態が続くと、昨年の台風や地震よりもさらに大きな災害が発生した時、日本を訪れる外国人観光客の命に係わる問題に発展することは必至であると思わざるを得ません。　世界のグローバル化によって、近年、わが国を訪れる外国人観光客や、仕事を求めて来日する外国人の数は増加の一途をたどっています。それに伴い、日本の社会は様々な領域において多様化・細分化が進んでいます。わが国は、これまでのモノづくりの国、貿易立国であったことに加え、今や観光立国や医療が中心のサービス産業社会になろうとしております。　そして、私たちは少子化による人口の減少と移民労働者の流入、それに外国人観光客の急増という新しい現実を目の当たりにし、これら三つ巴の問題に正面から向き合わねばならない時代へと突入しているのです。その意味において、国民の多くが「すぐに役に立つ英語」や「ホスピタリティー・イングリッシュ」さらに「非常時緊急支援英語」を身に付けていることが、モノづくり、貿易、それに、これからの観光産業やサービス産業を支えていく上で必要不可欠だ、と私は考えます。そのためには、若くて好奇心の旺盛な間に、なかでも学生時代に、コミュニケーションの道具としての外国語、とりわけ世界共通語である英';
  const [pitch, setPitch] = useState<any>(1);
  const [rate, setRate] = useState<any>(1);
  const [volume, setVolume] = useState<number>(1);
  const [voiceIndex, setVoiceIndex] = useState<number>(0);
  const [lang, setLang] = useState<string>();
  const [startActivePosition, setStartActivePosition] = useState<number>();
  const [endActivePosition, setEndActivePosition] = useState<number>(0);
  const [testText, setTestText] = useState<string>('');

  const onEnd = () => {
    setEndActivePosition(0);
    setStartActivePosition(undefined);
  };

  const onPause = (e: any) => {
    const char = e.utterance.text.charAt(e.charIndex);
    LogApp('PAUSE', char, e);
  };
  const onResume = (e: any) => {
    LogApp('RESUME', e);
  };

  const onBoundaryHandler = (e: SpeechSynthesisEvent) => {
    LogApp('HANDLE', e);
    const value = e.utterance.text;
    const index = e.charIndex;
    const length = e.charLength;
    const char = e.utterance.text.charAt(index);
    const word = getWordAt(value, index);
    const anchorPosition = getWordStart(value, index);
    const activePosition = anchorPosition + word.length;
    // const activePosition = anchorPosition + length;
    setTestText(
      'index:' +
        index +
        ',chart:' +
        char +
        ', charLength:' +
        length +
        ', anchorPosition:' +
        anchorPosition,
    );
    if (lang?.includes('ja')) {
      setStartActivePosition(index); //for japanese text
      setEndActivePosition(index + length);
    } else {
      setStartActivePosition(anchorPosition);
      setEndActivePosition(activePosition);
    }
    LogApp('HANDLE BOUND', { value }, { char }, index, { word }, anchorPosition, activePosition);
  };

  const { speak, cancel, pause, resume, speaking, supported, voices } = useSpeechSynthesis({
    onEnd,
    onPause,
    onResume,
    onBoundaryHandler,
  });

  LogApp('Voice Index', voiceIndex);

  const availableVoices = voices.filter((voice: SpeechSynthesisVoice) => voice.lang.includes('ja'));
  LogApp('availableVoices', availableVoices);

  const genWord = () => {
    const arrText = text.split('');
    const hightLightText = arrText.slice(startActivePosition || 0, endActivePosition).join('');
    const firstText = arrText.slice(0, startActivePosition || 0).join('');
    const endText = arrText.slice(endActivePosition, arrText.length).join('');
    return (
      <StyledWord>
        {firstText}
        <span className="hightLight-text">{hightLightText}</span>
        {endText}
      </StyledWord>
    );
  };

  const genJPWord = () => {
    const arrText = text.split('');
    const hightLightText = arrText
      .slice(
        startActivePosition || 0,
        startActivePosition ? startActivePosition + 1 : endActivePosition,
      )
      .join('');
    const firstText = arrText.slice(0, startActivePosition || 0).join('');
    const endText = arrText.slice(Number(startActivePosition) + 1, arrText.length).join('');
    return (
      <StyledWord>
        {firstText}
        <span className="hightLight-text">{hightLightText}</span>
        {endText}
      </StyledWord>
    );
  };

  return (
    <StyledViewBook>
      <form>
        {/* <h2>Speech Synthesis</h2> */}
        {!supported && <p>No Support</p>}
        {supported && (
          <React.Fragment>
            <label htmlFor="voice">Voice</label>
            <select
              id="voice"
              name="voice"
              value={voiceIndex || ''}
              onChange={(event) => {
                setVoiceIndex(Number(event.target.value));
              }}
            >
              {/* <option value="">Default</option> */}
              {availableVoices.map((option: any, index: number) => (
                <option key={option.voiceURI} value={index}>
                  {`${option.lang} - ${option.name}`}
                </option>
              ))}
            </select>
            <div
              style={{
                display: 'flex',
                marginBottom: 12,
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <label htmlFor="rate">Speed: </label>
                <div className="rate-value">{rate}</div>
              </div>
              <input
                type="range"
                min="0.5"
                max="2"
                defaultValue="1"
                step="0.1"
                id="rate"
                onChange={(event) => {
                  setRate(event.target.value);
                }}
              />
            </div>
            <div
              style={{
                display: 'flex',
                marginBottom: 12,
              }}
            >
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <label htmlFor="pitch">Pitch: </label>
                <div className="pitch-value">{pitch}</div>
              </div>
              <input
                type="range"
                min="0"
                max="2"
                defaultValue="1"
                step="0.1"
                id="pitch"
                onChange={(event) => {
                  setPitch(event.target.value);
                }}
              />
            </div>
            <label htmlFor="message">Message</label>

            <StyledPreviewBook>{genWord()}</StyledPreviewBook>
            <br />
            {/* <StyledPreviewBook>{genJPWord()}</StyledPreviewBook> */}
            <p>Test: {testText}</p>
            {speaking ? (
              <React.Fragment>
                <button type="button" onClick={cancel}>
                  Stop
                </button>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <button
                  type="button"
                  onClick={() => {
                    const voice: SpeechSynthesisVoice = availableVoices?.[voiceIndex];
                    const lang = voice?.lang;
                    setLang(voice?.lang);
                    speak({ text, voice, rate, pitch, volume, lang });
                  }}
                >
                  Speak
                </button>
              </React.Fragment>
            )}
            <button type="button" onClick={pause}>
              Pause
            </button>
            <button type="button" onClick={resume}>
              Resume
            </button>
          </React.Fragment>
        )}
      </form>
    </StyledViewBook>
  );
};

const StyledViewBook = styled.div`
  padding: 30px 1000px 0 50px;
`;

const StyledPreviewBook = styled.div`
  background-color: #f3f3f3;
  width: 500px;
  height: 300px;
  margin-bottom: 20px;
  padding: 20px;
  p {
    color: '#000';
    font-size: 12px;
  }
`;

const StyledWord = styled.div`
  color: '#000';
  font-size: 12px;
  .hightLight-text {
    background-color: #efe46a;
  }
`;
